// extracted by mini-css-extract-plugin
export var box = "_6h-1";
export var checked = "_6h-2";
export var descriptionSpacer = "_6h-9";
export var disabled = "_6h-3";
export var icon = "_6h-6";
export var input = "_6h-0";
export var labelSpacer = "_6h-8";
export var medium = "_6h-5";
export var small = "_6h-4";
export var text = "_6h-7";